// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wNwq","fullView":"styles_fullView__1yb4C"};